<div class="mapContent">
    <div class="container">
        <img src="../../../../assets/mapImage.png" alt="" class="mapImage">
    </div>
</div>